import { useI18n } from 'vue-i18n'
import { availableLocales } from '~/i18n/config'

export const useLocale = () => {
  const { locale } = useI18n()
  const { $changeLanguage } = useNuxtApp()

  // 获取当前语言
  const getCurrentLocale = () => {
    if (process.client) {
      return localStorage.getItem('locale') || locale.value
    }
    return locale.value
  }

  // 设置语言
  const setLocale = (newLocale: string) => {
    // 验证语言是否支持
    if (!availableLocales.some(l => l.code === newLocale)) {
      console.warn(`Unsupported locale: ${newLocale}`)
      return false
    }

    // 使用全局提供的 changeLanguage 方法
    if ($changeLanguage(newLocale)) {
      // 切换成功后刷新页面
      if (process.client) {
        window.location.reload()
      }
      return true
    }
    return false
  }

  // 初始化语言设置
  const initLocale = () => {
    if (process.client) {
      const savedLocale = localStorage.getItem('locale')
      if (savedLocale && availableLocales.some(l => l.code === savedLocale)) {
        // 初始化时不需要刷新页面
        if ($changeLanguage(savedLocale)) {
          return true
        }
      }
    }
    return false
  }

  return {
    getCurrentLocale,
    setLocale,
    initLocale,
    availableLocales
  }
} 